var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBotAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "url(#paint0_linear_103_625)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6173 26.8375L43.2893 27.5921C43.2381 27.715 43.1516 27.82 43.0408 27.8938C42.93 27.9677 42.7998 28.0071 42.6667 28.0071C42.5335 28.0071 42.4033 27.9677 42.2925 27.8938C42.1817 27.82 42.0953 27.715 42.044 27.5921L41.716 26.8375C41.1393 25.5024 40.0832 24.432 38.756 23.8375L37.744 23.3855C37.6212 23.329 37.5172 23.2385 37.4443 23.1247C37.3714 23.0109 37.3327 22.8786 37.3327 22.7435C37.3327 22.6083 37.3714 22.476 37.4443 22.3622C37.5172 22.2484 37.6212 22.1579 37.744 22.1015L38.7 21.6761C40.0605 21.0646 41.1347 19.9546 41.7013 18.5748L42.0387 17.7601C42.0882 17.6339 42.1746 17.5256 42.2866 17.4492C42.3987 17.3729 42.5311 17.332 42.6667 17.332C42.8022 17.332 42.9347 17.3729 43.0467 17.4492C43.1587 17.5256 43.2451 17.6339 43.2947 17.7601L43.632 18.5735C44.198 19.9536 45.2717 21.064 46.632 21.6761L47.5893 22.1028C47.7117 22.1594 47.8154 22.2499 47.888 22.3636C47.9606 22.4772 47.9992 22.6093 47.9992 22.7441C47.9992 22.879 47.9606 23.0111 47.888 23.1247C47.8154 23.2383 47.7117 23.3288 47.5893 23.3855L46.576 23.8361C45.2491 24.4313 44.1934 25.5022 43.6173 26.8375ZM29.3333 20.0001H34.6667V22.6668H29.3333C27.2116 22.6668 25.1768 23.5097 23.6765 25.01C22.1762 26.5102 21.3333 28.5451 21.3333 30.6668C21.3333 35.4801 24.616 38.6215 32 41.9735V38.6668H34.6667C36.7884 38.6668 38.8232 37.8239 40.3235 36.3237C41.8238 34.8234 42.6667 32.7885 42.6667 30.6668H45.3333C45.3333 33.4958 44.2095 36.2089 42.2091 38.2093C40.2088 40.2097 37.4956 41.3335 34.6667 41.3335V46.0001C28 43.3335 18.6667 39.3335 18.6667 30.6668C18.6667 27.8378 19.7905 25.1247 21.7909 23.1243C23.7913 21.1239 26.5044 20.0001 29.3333 20.0001Z",
    fill: "url(#paint1_linear_103_625)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_625",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_625",
    x1: 33.333,
    y1: 17.332,
    x2: 33.333,
    y2: 46.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotAi);
export default __webpack_public_path__ + "static/media/ChatBotAI.e88201436824d20fb0cb99a586ab6253.svg";
export { ForwardRef as ReactComponent };